export const tabs = () => {
	const tabs = document.querySelector('.tabs');

	if (!tabs) return;

	const buttons = tabs.querySelectorAll('.tabs-btn');
	const panes = tabs.querySelectorAll('.tabs-pane');

	if (!buttons.length || !panes.length) return;

	const changeEvent = new Event('tab.itc.change');

	const showTab = button => {
		const index = Number(button.dataset.index);
		const pane = panes[index];

		if (!pane) return;

		const activeButton = tabs.querySelector('.tabs-btn-active');
		const activePane = tabs.querySelector('.tabs-pane-show');

		if (button === activeButton) return;

		activeButton?.classList.remove('tabs-btn-active');
		activePane?.classList.remove('tabs-pane-show');

		button.classList.add('tabs-btn-active');
		pane.classList.add('tabs-pane-show');

		tabs.dispatchEvent(changeEvent);
		button.focus();
	};

	const showTabByIndex = index => {
		const button = buttons[index];

		if (!button) return;

		showTab(button);
	};

	tabs.setAttribute('role', 'tablist');

	buttons.forEach((button, index) => {
		const pane = panes[index];

		button.dataset.index = String(index);
		button.setAttribute('role', 'tab');

		pane?.setAttribute('role', 'tabpanel');
	});

	tabs.addEventListener('click', event => {
		const button = event.target.closest('.tabs-btn');

		if (!button || !tabs.contains(button)) return;

		event.preventDefault();
		showTab(button);
	});

	return {
		show: showTab,
		showByIndex: showTabByIndex,
	};
};